import { useMemo } from 'react';

export const useOrderReturn = (order: Conversation.Trade.Vo) => {
  const { items } = order;

  return useMemo(() => {
    const returnSnSet = new Set<string>();
    const returnItemIdSet = new Set<string>();
    items.forEach((item) => {
      item.refundReason?.forEach((r) => {
        if (r.returnSn) {
          returnSnSet.add(r.returnSn);
          returnItemIdSet.add(item.itemId);
        }
      });
    });
    return {
      returnSnList: Array.from(returnSnSet),
      returnItemIdList: Array.from(returnItemIdSet),
    };
  }, [items]);
};
